import { useCallback, useEffect, useState } from 'react';
import { WifiOutlined, DisconnectOutlined, CloseOutlined } from '@ant-design/icons';

const AppOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isRestoreOnline, setIsRestoreOnline] = useState(false);

  const handleOnlineStatus = useCallback(() => {
    setIsOnline(navigator.onLine);

    if (!isOnline && navigator.onLine) {
      setIsRestoreOnline(true);
      setTimeout(() => setIsRestoreOnline(false), 3000);
    }
  }, [isOnline]);

  useEffect(() => {
    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOnlineStatus);
    return () => {
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOnlineStatus);
    };
  }, [handleOnlineStatus]);

  if (!isOnline) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          padding: '6px 16px',
          background: '#ff4d4f',
          color: '#fff',
          fontSize: 13,
          fontWeight: 500,
          zIndex: 1000,
        }}
      >
        <DisconnectOutlined />
        <span>
          You are currently offline.{' '}
          <span
            onClick={() => window.location.reload()}
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
          >
            Refresh
          </span>
        </span>
      </div>
    );
  }

  if (isRestoreOnline) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          padding: '6px 16px',
          background: '#52c41a',
          color: '#fff',
          fontSize: 13,
          fontWeight: 500,
          zIndex: 1000,
        }}
      >
        <WifiOutlined />
        <span>Your Internet connection was restored</span>
        <CloseOutlined
          onClick={() => setIsRestoreOnline(false)}
          style={{ cursor: 'pointer', fontSize: 12 }}
        />
      </div>
    );
  }

  return null;
};

export default AppOnlineStatus;
